export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1597839219216-a773cb2473e4",
  studio: "https://images.unsplash.com/photo-1511406361295-0a1ff814c0ce",
  branding: "https://images.unsplash.com/photo-1772191399367-91ed8d95664b",
  print: "https://images.pexels.com/photos/13633367/pexels-photo-13633367.jpeg",
  packaging: "https://images.pexels.com/photos/5556277/pexels-photo-5556277.jpeg",
  editorial: "https://images.unsplash.com/photo-1777901513094-f8b4ca262d57",
  digital: "https://images.unsplash.com/photo-1785245566050-8aaa947c74b8",
  portrait: "https://customer-assets-39nsmqrw.emergentagent.net/job_remance-studio/artifacts/6m01wdu7_23E7472B-C529-4695-9A5A-6FA9BEF2A2D4.jpg",
};

export const PROJECTS = [
  {
    id: "lobsidienne",
    name: "L'Obsidienne",
    category: "Identité visuelle · Packaging",
    description: "Parfumerie artisanale — un monogramme sculpté et un flacon pensé comme un objet d'art.",
    image: IMAGES.branding,
    ratio: "aspect-[3/4]",
  },
  {
    id: "maison-vercors",
    name: "Maison Vercors",
    category: "Édition · Supports print",
    description: "Une collection de brochures et de catalogues au grain éditorial, composés avec exigence.",
    image: IMAGES.print,
    ratio: "aspect-[4/5]",
  },
  {
    id: "atelier-cevenol",
    name: "Atelier Cévenol",
    category: "Packaging · Print",
    description: "Maroquinerie d'art — pochettes, cartes et papeterie au noir profond et à l'or champagne.",
    image: IMAGES.packaging,
    ratio: "aspect-square",
  },
  {
    id: "heliade",
    name: "Héliade",
    category: "Direction artistique",
    description: "Campagne éditoriale — une lumière qui demeure, un regard qui marque.",
    image: IMAGES.editorial,
    ratio: "aspect-[3/4]",
  },
  {
    id: "domaine-astre",
    name: "Domaine Astré",
    category: "Site vitrine · Digital",
    description: "Un site sombre et cinématique pour un domaine viticole confidentiel.",
    image: IMAGES.digital,
    ratio: "aspect-[4/3]",
  },
  {
    id: "sentiers",
    name: "Sentiers",
    category: "Identité · Signalétique",
    description: "Office de tourisme — un système de signalétique élégant qui guide sans jamais brusquer.",
    image: IMAGES.studio,
    ratio: "aspect-[4/5]",
  },
];

export const SERVICES = [
  {
    num: "01",
    title: "Identité visuelle",
    tagline: "Donnez à votre entreprise une image reconnaissable.",
    description:
      "Nous créons des identités qui reflètent votre savoir-faire et renforcent votre crédibilité.",
    items: ["Logo sur mesure", "Charte graphique", "Palette de couleurs", "Typographies", "Cartes de visite", "Signature e-mail", "Papeterie professionnelle"],
    price: "À partir de 690 €",
    span: "md:col-span-7",
  },
  {
    num: "02",
    title: "Supports imprimés",
    tagline: "Des supports qui donnent envie d'être conservés.",
    description:
      "Parce qu'un flyer ou une brochure représentent votre entreprise, chaque détail compte.",
    items: ["Flyers", "Dépliants", "Brochures", "Catalogues", "Menus", "Affiches", "Roll-up", "Kakémonos", "Cartes de fidélité", "Bons cadeaux"],
    price: "Sur devis",
    span: "md:col-span-5",
  },
  {
    num: "03",
    title: "Communication digitale",
    tagline: "Une présence cohérente sur tous vos supports.",
    description: "Votre image ne s'arrête pas à votre logo.",
    items: ["Publications réseaux sociaux", "Bannières", "Publicités", "Visuels LinkedIn", "Templates Instagram", "Présentations PowerPoint"],
    price: "Sur devis",
    span: "md:col-span-5",
  },
  {
    num: "04",
    title: "Sites vitrines",
    tagline: "Votre entreprise mérite un site à son image.",
    description:
      "Un site clair, rapide et pensé pour transformer les visiteurs en prospects.",
    items: ["Design personnalisé", "Version mobile", "Formulaire de contact", "Optimisation SEO de base", "Hébergement possible"],
    price: "À partir de 990 €",
    span: "md:col-span-7",
  },
  {
    num: "05",
    title: "Signalétique",
    tagline: "Valorisez vos locaux et vos véhicules.",
    description:
      "Nous réalisons les fichiers destinés à la fabrication de vos supports grand format.",
    items: ["Enseignes", "Vitrophanies", "Covering de véhicules", "Panneaux", "Bâches", "Habillage de stands"],
    price: "Sur devis",
    span: "md:col-span-6",
  },
  {
    num: "06",
    title: "Accompagnement",
    tagline: "Une communication évolue avec votre activité.",
    description: "Un suivi mensuel pour faire grandir votre image dans la durée.",
    items: ["Création de nouveaux supports", "Mises à jour", "Publications", "Conseils", "Déclinaisons graphiques"],
    price: "Forfait mensuel sur devis",
    span: "md:col-span-6",
  },
];

export const FAQ = [
  {
    q: "À qui s'adressent vos services ?",
    a: "Aux artisans, commerçants, professions libérales, associations et PME souhaitant renforcer leur image avec des outils professionnels, durables et cohérents.",
  },
  {
    q: "Travaillez-vous à distance ?",
    a: "Oui. Les échanges peuvent se faire en visioconférence, par téléphone ou par e-mail. Nous accompagnons des projets partout en France.",
  },
  {
    q: "Fournissez-vous les fichiers sources ?",
    a: "Oui. Selon la prestation choisie, les fichiers livrés peuvent inclure les formats adaptés à l'impression et au web.",
  },
  {
    q: "Combien de temps faut-il pour créer un logo ?",
    a: "En général, comptez 2 à 4 semaines, selon le projet et les allers-retours de validation.",
  },
];

export const METHOD_STUDIO = [
  { num: "I", title: "Découvrir", text: "Nous échangeons sur votre activité, vos clients et vos ambitions." },
  { num: "II", title: "Imaginer", text: "Nous développons plusieurs pistes créatives adaptées à votre projet." },
  { num: "III", title: "Concevoir", text: "Nous affinons chaque détail jusqu'à obtenir une identité cohérente." },
  { num: "IV", title: "Déployer", text: "Votre identité est déclinée sur tous les supports nécessaires à votre communication." },
];

export const METHOD_SERVICES = [
  { num: "01", title: "Découverte", text: "Nous échangeons sur votre activité." },
  { num: "02", title: "Proposition", text: "Vous recevez une proposition claire accompagnée d'un devis." },
  { num: "03", title: "Création", text: "Nous développons votre projet étape par étape." },
  { num: "04", title: "Livraison", text: "Vous recevez tous les fichiers nécessaires pour exploiter votre nouvelle identité." },
];

export const VALUES = [
  { title: "Écoute", text: "Comprendre avant de créer." },
  { title: "Exigence", text: "Chaque détail compte." },
  { title: "Pérennité", text: "Concevoir des identités qui restent actuelles dans le temps." },
  { title: "Proximité", text: "Un accompagnement humain, simple et réactif." },
];
